//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountUsageMessage",
  props: {
    usageRestricted: {
      type: Boolean,
      default: false
    },
    page: {
      type: String,
      required: true
    },
    remainingUsages: {
      type: Number,
      default: 0
    }
  },
  computed: {
    currentPageLabel() {
      return this.$t("account.accountUsage.pages")[this.page];
    }
  }
});